import { useEffect, useState } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import * as pas from 'js/hooks/auth/pas';
import { useLocation } from 'react-router-dom';
import { getCleanPath } from 'js/utils/url.util';
import { useNavigate } from 'js/hooks/navigate';
import { storageService } from 'js/services/storage.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

import { SESSION_STORAGE_KEY } from './constants';

export const DynamicClientType = ({ config }) => {
    const { clientTypeQueryStringPages, clientTypeGroups } = config;
    const { state, pathname } = useLocation();
    const [clientType, setClientType] = useState(storageService.session.getItem(SESSION_STORAGE_KEY));
    const navigateWithReplace = useNavigate({ replace: true });

    /**
     * If clientType has changed, ensure to set it in PAS and store it in sessionStorage.
     */
    useEffect(() => {
        if (!clientType) {
            return;
        }

        storageService.session.setItem(SESSION_STORAGE_KEY, clientType);
        pas.setClientType(clientType);
    }, [
        clientType
    ]);

    /**
     * Either adds or removes ?clientType=x parameter from the Query String.
     * The parameter is them picked up in other components over whole portal.
     */
    useEffect(() => {
        if (!clientType) {
            return;
        }

        const cleanPath = getCleanPath(window.location.pathname);

        if (clientTypeQueryStringPages.some((entry) => entry.page === cleanPath)) {
            navigateWithReplace(`${cleanPath}?clientType=${clientType}`, undefined, { preserveHash: true });
        } else {
            navigateWithReplace(cleanPath, state, { removeParams: ['clientType'], preserveHash: true });
        }
    }, [
        state,
        clientType,
        navigateWithReplace,
        clientTypeQueryStringPages
    ]);

    /**
     * Changes internal clientType based on the current page URL.
     */
    useEffect(() => {
        const cleanPath = getCleanPath(pathname);

        for (const clientTypeGroup of clientTypeGroups) {
            if (clientTypeGroup.pages.some((entry) => entry.page === cleanPath)) {
                setClientType(clientTypeGroup.clientType);
                return;
            }
        }
    }, [
        pathname,
        clientTypeGroups
    ]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.dynamicClientType]: DynamicClientType });
